import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {
  acceleratorBannerCurrentDate,
  acceleratorBannerEndDate,
  acceleratorBannerStartDate,
  acceleratorBannerTotalOECount,
} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {currentScreen} from '/redux/selector/navigation.selector';
import {
  variablesBannerText,
  variablesBonusDisplayDate,
} from '/redux/selector/remoteConfig.selector';
import {withProps} from '/util/selector.util';

import {CoachAcceleratorBonusBanner} from './CoachAcceleratorBonusBanner';

const withCurrentUserCoachId = withProps({coachId: userId});

export default connect(
  createStructuredSelector({
    totalOECount: withCurrentUserCoachId(acceleratorBannerTotalOECount),
    currentDate: withCurrentUserCoachId(acceleratorBannerCurrentDate),
    startDate: withCurrentUserCoachId(acceleratorBannerStartDate),
    endDate: withCurrentUserCoachId(acceleratorBannerEndDate),
    currentScreen: currentScreen,
    bannerText: variablesBannerText,
    doubleDoubleBonusPeriod: variablesBonusDisplayDate,
  }),
  _dispatch => ({}),
  (stateProps, dispatchProps, ownProps) => {
    return {
      ...stateProps,
      ...dispatchProps,
      ...ownProps,
    };
  },
)(CoachAcceleratorBonusBanner);
